// 增添購物車遮罩
const maskHtml =
  '<div class="Modal-mask" id="cartMask" style="display: none;z-index:1"></div>';
document.getElementsByTagName("body")[0].innerHTML += maskHtml;


